import { AuthenticatedUser } from '@shared/Authentication';
import { option } from 'fp-ts';
import { Option } from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';

export type ReportableUser = {
  id?: number;
  phone?: string;
};

export namespace ReportableUser {
  export const from = (user: AuthenticatedUser | undefined | null): Option<ReportableUser> =>
    pipe(
      option.fromNullable(user),

      option.map((user) => ({
        id: user.id,
        phone: user.phoneNumber,
      }))
    );
}
